import React from "react";
import { ConnectionTypes } from "./ConnectivitySection";

function ConnectionTypeRadio({ connectionType }) {
    const options = [
        { value: ConnectionTypes.API, label: "API URL" },
        { value: ConnectionTypes.SSH, label: "SSH" },
        { value: ConnectionTypes.WINRM, label: "WinRM" },
        { value: ConnectionTypes.PowerCLI, label: "PowerCLI" },
        { value: ConnectionTypes.M365, label: "M365" }
    ];

    return (
        <>
            <div className="oct_form-title">Connection Type <span className="modal-v2-required-mark">*</span></div>
            <div className="form-inline form-group modal-v2-choice-group">
                {options.map((option) => (
                    <div className="oct_radio" key={option.value}>
                        <label className="oct_radio-label modal-v2-choice-label">
                            <input
                                type="radio"
                                name="connection-type"
                                className="modal-v2-choice-input"
                                disabled={true}
                                checked={connectionType === option.value}
                                value={option.value}
                                readOnly
                            />
                            <span className="font-weight-bold">{option.label}</span>
                        </label>
                    </div>
                ))}
            </div>
        </>
    )
}

export default ConnectionTypeRadio;
